export enum ThirdPartyType {
  ADMIT_ONE = 1,
  /** Delivery Provider */
  DELIVERY_PROVIDER = 2
}
